import { SPACE_AFTER_FLAG_REGEX } from '@monoimin/constants';

export function removeSpaceAfterFlag(string: string) {
  return string.replace(SPACE_AFTER_FLAG_REGEX, '!$1');
}

export default removeSpaceAfterFlag;
